import { TextLineSkeleton, TitleSkeleton } from 'components/patterns/Skeleton/blocks/TextLineSkeleton'
import {
	BlockSkeleton,
	CircleSkeleton,
	GreedySkeleton,
	SquareSkeleton
} from 'components/patterns/Skeleton/blocks/ShapedSkeletons'
import React, { CSSProperties, ReactNode } from 'react'
import { ReactComponentLike } from 'prop-types'

export enum SkeletonType {
	title = 'title',
	line = 'line',
	paragraph = 'paragraph',
	square = 'square',
	circle = 'circle',
	block = 'block'
}

export const getSkeletonByType = (type: SkeletonType): JSX.Element => {
	switch (type) {
		case SkeletonType.title:
			return <TitleSkeleton />
			break
		case SkeletonType.line:
			return <TextLineSkeleton />
			break
		case SkeletonType.paragraph:
			return (
				<>
					{Array(3)
						.fill(Math.random())
						.map((x, index) => (
							<TextLineSkeleton key={index} />
						))}
				</>
			)
			break
		case SkeletonType.square:
			return <SquareSkeleton />
			break
		case SkeletonType.circle:
			return <CircleSkeleton />
			break
		case SkeletonType.block:
			return <BlockSkeleton />
			break
	}
}

/**
 * wrapper for chained optionals that returns a skeleton while they are undefined
 * @param val
 * @param type
 */
export const sk = (val: ReactNode, type: SkeletonType = SkeletonType.line): ReactNode => {
	return val ? val : getSkeletonByType(type)
}

const UnsetNonContainerStyles: Partial<CSSProperties> = {
	padding: 0,
	backgroundColor: 'unset'
}

/**
 * No hope of typing this sucker manually. So we let the compiler.
 */

/**
 * Creates a loader out of any styled-component
 * @param Component
 * @param styleOverrides
 */
export const skComponent = (
	Component: ReactComponentLike,
	styleOverrides: Partial<React.CSSProperties> = {}
): JSX.Element => {
	return (
		<Component as={'div'} style={{ ...UnsetNonContainerStyles, ...styleOverrides }}>
			<GreedySkeleton />
		</Component>
	)
}

/**
 * Generates a list of components
 * @param generator
 * @param count
 */
export const generateComponents = (generator: (key: number) => JSX.Element, count: number): JSX.Element => {
	const array = new Array(count).fill(Math.random)
	return <>{array.map((x, i) => generator(i))}</>
}
